"use client";
import { useEffect, useState } from "react";
import { gtagEvent } from "../layout";
import "../stylesheets/main.scss";
import "../stylesheets/backToTop.scss";

export default function BackToTop() {
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    const urlSearchParams = new URLSearchParams(window.location.search);
    if (urlSearchParams.has("dev")) return;
    let timeout;
    const minutesOfInactivity = 2.5;

    const resetTimer = () => {
      clearTimeout(timeout);
      timeout = setTimeout(() => {
        gtagEvent("inactivity_reset", {
          category: "User Behavior",
          label: "inactive_reset_site_to_start",
        });
        restartExperince();
      }, 1000 * 60 * minutesOfInactivity);
    };

    const interactions = [
      "mousemove",
      "keydown",
      "scroll",
      "click",
      "touchmove",
    ];

    interactions.forEach((event) => window.addEventListener(event, resetTimer));

    resetTimer();

    const homeIntro = document.querySelector(".home-intro");
    if (homeIntro) {
      const homeIntroHeight = homeIntro ? homeIntro.offsetHeight : 0;
      window.addEventListener("scroll", () => {
        if (window.scrollY >= homeIntroHeight) {
          setIsVisible(true);
        } else setIsVisible(false);
      });
    } else {
      setIsVisible(true);
    }
  }, []);

  return (
    <button
      className={`backToTop ${isVisible ? "visible" : ""}`}
      onClick={() => {
        gtagEvent("restart_button_clicked", {
          category: "navigation",
          label: "restart_button_clicked",
        });
        restartExperince();
      }}
    >
      restart
    </button>
  );
}

export function restartExperince() {
  const queryParams = window.location.search;
  if (window.location.pathname === "/") {
    window.scrollTo({ top: 0, behavior: "smooth" });
  } else {
    window.scrollTo({ top: 100, behavior: "smooth" });
    window.location.href = "/" + queryParams;
  }
}
